import { SVGProps } from 'react';

const SvgClearCircleOutline = (props: SVGProps<SVGSVGElement>) => (
    <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 16 16" {...props}>
        <path d="m10.828 6.114-.942-.942L8 7.057 6.114 5.172l-.942.942L7.057 8 5.172 9.886l.942.942L8 8.943l1.886 1.885.942-.942L8.943 8l1.885-1.886Zm1.886-2.828a6.669 6.669 0 0 0-9.428 0 6.669 6.669 0 0 0 0 9.428 6.669 6.669 0 0 0 9.428 0 6.669 6.669 0 0 0 0-9.428ZM4.229 11.77a5.34 5.34 0 0 1 0-7.542 5.34 5.34 0 0 1 7.542 0 5.34 5.34 0 0 1 0 7.542 5.34 5.34 0 0 1-7.542 0Z" />
    </svg>
);
export default SvgClearCircleOutline;
